import React, { createContext, useContext, useState } from 'react';
import es from './locales/es';
import eu from './locales/eu';
import en from './locales/en';

const locales = { es, eu, en };

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('bfpe_lang') || 'es';
  });

  /**
   * Retrieve a translation by dot-notation key.
   * Supports variable substitution: t('key', { var: value })
   * Returns the raw value if it's not a string (array, object, etc.)
   */
  const t = (key, vars) => {
    const keys = key.split('.');
    let value = locales[language];
    for (const k of keys) {
      value = value?.[k];
    }
    if (value === undefined || value === null) return key;
    if (typeof value !== 'string') return value;
    if (vars) {
      return Object.entries(vars).reduce(
        (str, [k, v]) => str.replace(new RegExp(`\\{${k}\\}`, 'g'), v),
        value
      );
    }
    return value;
  };

  const changeLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem('bfpe_lang', lang);
  };

  return (
    <LanguageContext.Provider value={{ t, language, setLanguage: changeLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useLanguage must be used within LanguageProvider');
  return ctx;
};
